<template>
  <li class="dropdown-menu-footer p-1">
    <div class="d-flex justify-content-between">
      <h5 class="mb-0">
        Ext: {{ device.user }} - {{ isConnected }}
        <b-button
          v-if="
            isConnected != 'Connected' &&
            $can('force_connect', 'DeviceInterphone')
          "
          class="m-1 btn-sm"
          variant="success"
          @click="forceConnectSIP"
          >{{ $t("sip.dropdown.connect") }}</b-button
        >
        <b-button
          v-if="
            isConnected == 'Connected' &&
            $can('force_disconnect', 'DeviceInterphone')
          "
          class="ml-1 btn-sm"
          variant="danger"
          @click="disconnectSIP"
          >{{ $t("sip.dropdown.disconnect") }}</b-button
        >
      </h5>

      <b-badge pill variant="light-success" v-if="isOnCall && isSameActiveProvider()">
        {{ $t("sip.dropdown.on_call_with") + " " + getCallingDisplay() }}
      </b-badge>
      <b-badge class="on-call" pill variant="light-warning" v-if="isCalling">
        {{ $t("sip.dropdown.calling_to") + " " + callingNumber }}
      </b-badge>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="isSameActiveProvider() && isOnCall && (presavedAlarm.router || (presavedAlarm.alarmJson && presavedAlarm.alarmJson.id_router))"
    >
      <b-badge pill variant="light-danger" class="m-1">
        {{
          $t("sip.dropdown.alarm_from") +
          " " +
          presavedAlarm.alarmJson.unit_name
        }}
      </b-badge>

      <b-badge pill variant="dark" class="m-1">
        {{ presavedAlarm.alarmJson.alarm_acronym }}
      </b-badge>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="isSameActiveProvider() && isOnCall && presavedAlarm.alarmJson"
    >
      <b-button
        class="m-1 btn-sm"
        variant="success"
        @click="alarmAction(presavedAlarm, 'confirmed')"
        v-if="presavedAlarm.alarmJson.alarm_status != 'attending'"
        >{{ $t("grid.slots.info.btns.confirmed") }}</b-button
      >

      <b-button
        class="m-1 btn-sm"
        variant="success"
        @click="alarmAction(presavedAlarm, 'attended')"
        v-if="presavedAlarm.alarmJson.alarm_status == 'attending'"
        >{{ $t("grid.slots.info.btns.attended") }}</b-button
      >

      <b-button
        class="m-1 btn-sm"
        variant="danger"
        @click="alarmAction(presavedAlarm, 'canceled')"
        >{{ $t("grid.slots.info.btns.cancel") }}</b-button
      >

      <b-button
        class="m-1 btn-sm"
        variant="light"
        @click="alarmShowRow(presavedAlarm)"
        >{{ $t("sip.dropdown.show_alarm") }}</b-button
      >

      <b-button
        class="m-1 btn-sm"
        variant="info"
        @click="alarmShowConfig(presavedAlarm)"
        >{{ $t("grid.widgets.alarms.menu.display") }}</b-button
      >
    </div>

    <div class="d-flex justify-content-between mt-1">
      <audio id="remoteAudio" controls>
        <p>Your browser doesn't support HTML5 audio.</p>
      </audio>
      <!-- <audio id="localAudio" controls>
            <p>Your browser doesn't support HTML5 audio.</p>
          </audio> -->
      <b-button
        class="mx-1"
        variant="light"
        @click="mute"
        v-if="(isOnCall || isCalling) && isSameActiveProvider()"
      >
        <feather-icon :icon="isMuted ? 'MicOffIcon' : 'MicIcon'" size="16" />
      </b-button>
      <b-button
        variant="danger"
        @click="hangUp"
        v-if="isSameActiveProvider() && (isOnCall || isCalling)"
        >{{ $t("sip.dropdown.hang_up") }}</b-button
      >
      <!-- <b-button
        class="m-1"
        variant="warning"
        @click="holdSession"
        v-if="isOnCall && !isHolded && userData.is_master_admin"
        >{{ $t("sip.dropdown.hold") }}</b-button
      >

      <b-button
        class="m-1"
        variant="warning"
        @click="unHoldSession"
        v-if="isHolded && userData.is_master_admin"
        >{{ $t("sip.dropdown.unhold") }}</b-button
      > -->

      <!-- <b-button
        class="m-1 btn-sm"
        variant="info"
        @click="activateRelay()"
        v-if="userData.is_master_admin"
        >Relay</b-button
      >
      <div v-if="userData.is_master_admin">
        <b-form-input
          id="transferUser"
          v-model="transferUser"
          trim
          v-if="userData.is_master_admin"
        />
        <b-button
          class="m-1 btn-sm"
          variant="info"
          @click="transferCall()"
          v-if="userData.is_master_admin"
          >Transfer</b-button
        >
      </div> -->
    </div>
  </li>
</template>

<script>
import { Web, URI } from "sip.js";
const {
  SimpleUser,
  simpleUserDelegate,
  RegistererUnregisterOptions,
  Inviter,
  UserAgent,
} = Web;
import { EventBus } from "@/libs/event-bus";

import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { computed, ref, onMounted, onUnmounted } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import axios from "@axios";
import useIotcomms from "@/composables/pbx/iotcomms";
import useOmnicloud from "@/composables/pbx/omnicloud";
import { getUserData } from "@/auth/utils";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const userData = getUserData();

    const callingNumber = ref("");
    const callRecieved = ref({ callingPartyNumber: "" });
    const toast = useToast();
    const isRegistered = store.state.sip.isRegistered;
    const presavedAlarm = computed(() => {
      return store.state.sip.presavedAlarm;
    });
    const presavedCaller = store.state.sip.presavedCaller;
    const transferUser = ref("");

    let driver = null;

    if (props.device.provider == "iotcomms") driver = useIotcomms;
    else driver = useOmnicloud;

    const activeSessionProvider = computed(
      () => store.state.sip.activeSessionProvider
    );

    const {
      isOnCall,
      isRinging,
      isCalling,
      isConnected,
      isMuted,
      isHolded,

      createUser,
      disconnectSIP,
      connect,
      hangUp,
      makeCall,
      makeCallWithPresavedCall,
      mute,
      transferCall,
      holdSession,
      unHoldSession,
      forceConnectSIP,
      setUpInterval,
      shouldDisconnect,
    } = driver(props.device);

    onMounted(() => {
      let audioElementAgain = document.getElementById("remoteAudio");
      let audioElementLocal = document.getElementById("localAudio");

      if (props.device.provider == "iotcomms") {
        store
          .dispatch("sip/getStatus", {
            device_id: props.device.user,
          })
          .then((response) => {
            if (response.data[0].status != "registered") {
              // if (!props.device.register) {
              createUser(audioElementAgain, audioElementLocal)
                .then((simpleUser) => {
                  //console.log("WebsocketUrl:" + webSocketServer)
                  connect();
                })
                .catch((e) => console.error(e));

              setUpInterval();

              toast({
                component: ToastificationContent,
                props: {
                  title: "Sip Registered " + props.device.user,
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
            } else {
              store.dispatch("sip/setIconColor", "red");
              toast({
                component: ToastificationContent,
                props: {
                  title:
                    "Ya existe una extensión registrada" + props.device.user,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            }
          })
          .catch((e) => {
            console.error({ e });
            store.dispatch("sip/setIconColor", "red");
            toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Ocurrió un error al obtener la extensión",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              },
              {
                timeout: 10000,
              }
            );
          })
          .finally(() => {});
      } else {
        // if (!props.device.register) {
        createUser(audioElementAgain, audioElementLocal)
          .then((simpleUser) => {
            //console.log("WebsocketUrl:" + webSocketServer)
            connect();
          })
          .catch((e) => console.error(e));

        setUpInterval();

        toast({
          component: ToastificationContent,
          props: {
            title: "Sip Registered " + props.device.user,
            icon: "CheckIcon",
            variant: "success",
          },
        });
      }

      EventBus.on(`call_device`, (params) => {
        if (params.provider == props.device.provider) {
          makeCall("sip:" + params.id + "@" + props.device.domain);
          callingNumber.value = params.id;
        }
      });

      EventBus.on(`call_device_presaved_call`, (data) => {
        if (isConnected.value != "Disconnected") {
          makeCallWithPresavedCall({ ...data });
          callingNumber.value = data.callingPartyNumber;
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: "No esta conectada la extensión del usuario",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      });


      EventBus.on(`call_device_from_alarm_omnicloud`, (params) => {
        if (params.provider == props.device.provider) {
          makeCall("sip:" + params.deviceToCall + "@" + props.device.domain);
          callingNumber.value = params.deviceToCall;
          store.dispatch("sip/setOmnicloudAlarm", params.id_alarm);
          setTimeout(() => {
            store.dispatch("sip/setOmnicloudAlarm", "");
          }, 10000);
        }
      });

      // }

      EventBus.on(`disconnect_sip-general`, (params) => {
        if (shouldDisconnect.value) {
          if (
            isConnected.value == "Connected" &&
            !isOnCall.value &&
            !isRinging.value
          )
            disconnectSIP();
        }
      });

      let sanitazedDomain = props.device.domain.replace(/[@.\/:]/g, "");
      EventBus.on(`disconnect_sip-${sanitazedDomain}`, (params) => {
        if (shouldDisconnect.value) {
          if (
            isConnected.value == "Connected" &&
            !isOnCall.value &&
            !isRinging.value
          )
            disconnectSIP();
        }
      });
    });

    onUnmounted(() => {
      store.dispatch("sip/unSubscribeToCalls", { user_id: userData.id });
      disconnectSIP();
    });

    window.addEventListener(
      "beforeunload",
      function (e) {
        //if (isConnected.value == "Connected") disconnectSIP();
        disconnectSIP();
      },
      false
    );

    const activateRelay = () => {
      console.log(simpleUser.session.sessionDescriptionHandler.sendDtmf(1));
    };

    const alarmAction = async (alarm_call, action) => {
      const alarm = alarm_call.alarmJson;
      store.dispatch("grid/setSelectedAlarm", { action, alarm }).then(() => {
        EventBus.emit("show-alarm-modal", "alarm_action_modal");
      });
    };

    const alarmShowConfig = async (alarm_call) => {
      const alarm = alarm_call.alarmJson;
      EventBus.emit("show-alarm-config", alarm);
    };

    const alarmShowRow = async (alarm_call) => {
      const alarm = alarm_call.alarmJson;
      EventBus.emit("show-alarm-row", alarm);
    };

    const getCallingDisplay = () => {
      if (
        callRecieved.value.callingPartyNumber &&
        callRecieved.value.callingPartyNumber !== ""
      ) {
        return callRecieved.value.callingPartyNumber;
      } else if (callingNumber.value && callingNumber.value !== "") {
        return callingNumber.value;
      } else if (presavedCaller.value && presavedCaller.value !== "") {
        return presavedCaller.value;
      } else if (
        presavedAlarm.value.alarmJson &&
        presavedAlarm.value.alarmJson.unit_name !== ""
      ) {
        return presavedAlarm.value.alarmJson.unit_name;
      } else {
        return "";
      }
    };

    const isSameActiveProvider = () => {
      if (presavedAlarm.value.alarmJson) console.log ('unit_json', JSON.stringify(presavedAlarm.value.alarmJson))
      return activeSessionProvider.value === props.device.provider;
    };

    return {
      hangUp,
      isOnCall,
      isConnected,
      isRinging,
      isCalling,
      isMuted,
      mute,
      callRecieved,
      callingNumber,
      isRegistered,
      disconnectSIP,
      presavedAlarm,
      alarmAction,
      alarmShowConfig,
      alarmShowRow,
      activateRelay,
      transferUser,
      holdSession,
      unHoldSession,
      isHolded,
      forceConnectSIP,
      shouldDisconnect,
      userData,
      transferCall,
      presavedCaller,
      getCallingDisplay,
      isSameActiveProvider,
    };
  },
};
</script>

<style lang="scss">
.on-call {
  -webkit-animation: flash linear 1s infinite;
  animation: flash linear 1s infinite;
}

@-webkit-keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
</style>
